import { render } from "./Separator.vue?vue&type=template&id=62af51b2&scoped=true"
import script from "./Separator.vue?vue&type=script&lang=ts"
export * from "./Separator.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-62af51b2"

export default script